import Header from '../../components/Header/Header';
import { Link } from 'react-router-dom';
import { useEffect } from 'react';
import { hasPermissions, hasRole, validateJwt } from '../../utils/functions';
import './Dashboard.css';
import Footer from '../../components/Footer/Footer';
import React from 'react';

function Dashboard() {
    useEffect(() => {
        validateJwt();
    }, []);
    const dashboardItems = [
        {
            title: 'CSIP Overview',
            img: '/csip.jpg',
            path: '/csip',
            permissions: ['csip'],
        },
        {
            title: 'Standards Dashboard',
            img: '/CSIP.png',
            path: '/isslc',
            permissions: ['dashboard'],
        },
        {
            title: 'Users',
            img: '/users.jpeg',
            path: '/users',
            permissions: [],
        },
    ];
    return (
        <>
            <Header title={'Dashboard'} />
            <main className={'dashboard-container container'}>
                {dashboardItems.map((item, index) => {
                    if (!hasRole('admin') && !hasPermissions(item.permissions)) {
                        return <></>;
                    }
                    return (
                        <div key={index} className={'dashboard-item'}>
                            <Link to={item.path}>
                                <img src={item.img} />

                                <h3>{item.title}</h3>
                            </Link>
                        </div>
                    );
                })}
            </main>
            <Footer />
        </>
    );
}

export default Dashboard;
